import React from "react";

import { OrgRecommendationData } from "../../../../models/OrgRecommendationData";
import TipsIcon from "../../../TipsIcon";

import "./styles.scss";

export const Suggestion = ({ data }: { data: OrgRecommendationData }) => {
  // TODO: This is a temporary fix while we work on the prompt for the `has_min_local_categories`
  // suggestion. Remove this once the AI generated suggestion is properly working again.
  const isHasMinLocalCategories =
    data.title === "より幅広いジャンルの最新投稿を行うことをおすすめします。";

  // This is hardcoded temporarily as well.
  const TIPS_ICON_LABEL =
    "更新：新たな最新情報を投稿\n" +
    "特典：クーポンコード等の来店特典を掲載\n" +
    "イベント：イベントの告知などを掲載、イベント終了後、投稿は自動削除されます";

  return (
    <div className="txt">
      <span className="points"></span>
      <div>
        <div className="suggestion-title">
          {data.title ? <strong>{data.title}</strong> : <></>}
        </div>
        <div className="suggestion-body">
          {data.body}
          {/* This is a temporary fix while we work on the prompt for the `has_min_local_categories`
          suggestion. Remove this once the AI generated suggestion is properly working again. */}
          {isHasMinLocalCategories && <TipsIcon tipsLabel={TIPS_ICON_LABEL} />}
        </div>
      </div>
    </div>
  );
};
